import styles from './styles.less';
import { observer } from 'mobx-react';


function LoadingSpinner(props) {
    return (
        <div className={ cx(styles.root, props.className) } />
    );
}


export default observer(LoadingSpinner);



// WEBPACK FOOTER //
// ./src/common/components/loading-spinner/index.js